import { render, staticRenderFns } from "./returnsIcon.vue?vue&type=template&id=b6d72fd8&"
import script from "./returnsIcon.vue?vue&type=script&lang=js&"
export * from "./returnsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports